import { erpAxios } from '..';

const addApplication = async (data) => {
  const res = await erpAxios.post(`/loanApplication/add`, data);
  return res ? res : null;
};

export default addApplication;
